module.exports = __webpack_public_path__ + "static/img/common-top.744ce28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common-top.png
// module id = KHby
// module chunks = 2